/**
 * Constants for intl-tel-input number formats
 * These correspond to the formats available in window.intlTelInputUtils.numberFormat
 */
export enum IntlTelInputNumberFormat {
  E164 = 0,           // +14155552671
  INTERNATIONAL = 1,  // +1 415 555 2671
  NATIONAL = 2,       // (415) 555-2671
  RFC3966 = 3         // tel:+1-415-555-2671
}

/**
 * Validation error codes from intl-tel-input
 */
export enum IntlTelInputValidationError {
  IS_POSSIBLE = 0,
  INVALID_COUNTRY_CODE = 1,
  TOO_SHORT = 2,
  TOO_LONG = 3,
  IS_POSSIBLE_LOCAL_ONLY = 4,
  INVALID_LENGTH = 5
}

/**
 * Common country codes (ISO 3166-1 alpha-2)
 */
export const COUNTRY_CODES = {
  CANADA: 'ca',
  USA: 'us',
  UK: 'gb',
  AUSTRALIA: 'au',
  GERMANY: 'de',
  FRANCE: 'fr',
  SPAIN: 'es',
  ITALY: 'it',
  JAPAN: 'jp',
  CHINA: 'cn',
  INDIA: 'in',
  BRAZIL: 'br',
  MEXICO: 'mx'
} as const;
